<template>
  <n-spin :show="showLoader">
    <ChangePasswordModal
      v-model:show="showChangePasswordModal"
      :username="formData.username"
      :temp-password="tempPassword"
      @cancel="handleChangePasswordCancel"
      @success="handleChangePasswordSuccess"
    />
    <section class="section-login">
      <div class="container-content">
        <div class="firstForm">
          <div class="login-section">
            <div class="login-wrapper logos-only">
              <div class="logos-wrapper">
                <template v-if="!showTestSections">
                  <a href="https://www.rodenstock.com/" target="_blank" rel="noopener noreferrer">
                    <img
                      src="@/assets/login/logos/Rodenstock Logo.png"
                      alt="Rodenstock Logo"
                      class="wrapper__logo"
                    />
                  </a>
                  <a href="https://indooptical.com/es/" target="_blank" rel="noopener noreferrer">
                    <img
                      src="@/assets/login/logos/Login Screen Logo.png"
                      alt="Indo Logo"
                      class="wrapper__logo"
                    />
                  </a>
                </template>
                <a
                  href="https://www.optovision.com/en/index.html"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="@/assets/login/logos/Optovision Black Logo.png"
                    alt="Optovision Logo"
                    class="wrapper__logo wrapper__logo--optovision"
                  />
                </a>
              </div>
            </div>
            <div class="login-wrapper form-only">
              <div class="flex justify-end mb-2 sm:mb-3 md:mb-4 w-full">
                <LanguageSelector />
              </div>
              <h2 class="title">{{ $t("bienvenido") }}</h2>
              <p class="text">{{ $t("para_empezar_inicia_sesion_con_tu_cuenta") }}</p>
              <n-form
                ref="formRef"
                :model="formData"
                :rules="rules"
                @submit.prevent="validate"
                :size="isSmallScreen ? 'small' : isLargeScreen ? 'medium' : 'large'"
              >
                <n-form-item path="username" :label="$t('usuario')">
                  <n-input
                    v-model:value="formData.username"
                    :placeholder="$t('escribe_aqui_tu_usuario')"
                    autocomplete="username"
                    autocapitalize="none"
                    clearable
                  />
                </n-form-item>
                <n-form-item path="password" :label="$t('contrasena')">
                  <n-input
                    v-model:value="formData.password"
                    type="password"
                    :placeholder="$t('escribe_aqui_tu_contrasena')"
                    autocomplete="current-password"
                    show-password-on="click"
                    clearable
                  />
                </n-form-item>
                <div v-if="error" class="error-message">
                  {{ errorMessage }}
                </div>
                <div class="checkbox-wrapper">
                  <n-checkbox v-model:checked="remember" class="remember-checkbox">
                    {{ $t("recordarme") }}
                  </n-checkbox>
                  <router-link to="/remember-password" class="forgot-link">
                    {{ $t("has_olvidado_tu_contrasena") }}
                  </router-link>
                </div>
                <n-form-item>
                  <n-button type="primary" attr-type="submit" block>
                    {{ $t("iniciar_sesion") }}
                  </n-button>
                </n-form-item>
              </n-form>
              <a
                v-if="!showTestSections"
                class="logo_bottom"
                href="https://indoonestop.jellibylab.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  class="align"
                  src="../assets/login/logos/logo-rodenstockgroup.png"
                  alt="rodenstockgroup-logo"
                />
              </a>
              <a class="text-sm text-theme-muted">v{{ appVersion }}</a>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="info-section">
        <div class="container-content">
          <div class="content-wrapper">
            <div class="title">
              {{ $t("unete_a_la_nueva_plataforma_para_profesionales_con_la_tecnologia_mas_avanzada") }}
            </div>
            <a
              href="http://indoonestop.jellibylab.com/solicitar-informacion"
              target="_blank"
              rel="noopener noreferrer"
              class="secundary-button"
            >
              {{ $t("solicitar_informacion") }}
            </a>
          </div>
        </div>
      </div> -->
    </section>
  </n-spin>
</template>

<script>
import { useIndoStore } from "@/stores/indo";
import { useAuthStore } from "@/stores/auth";
import sessionService from "@/services/session";
import { NForm, NFormItem, NInput, NButton, NCheckbox, NSpin } from "naive-ui";

import LanguageSelector from "@/components/atoms/LanguageSelector.vue";
import ChangePasswordModal from "@/components/sections/password/ChangePasswordModal.vue";

export default {
  name: "LoginView",
  components: {
    NForm,
    NFormItem,
    NInput,
    NButton,
    NCheckbox,
    NSpin,

    LanguageSelector,
    ChangePasswordModal,
  },
  data: () => ({
    formData: {
      username: "",
      password: "",
    },
    remember: false,
    error: false,
    errorMessage: "",
    showLoader: false,
    isSmallScreen: false,
    isLargeScreen: false,
    showTestSections: import.meta.env.VITE_MODO_OPTOVISION === "true",
    showChangePasswordModal: false,
    appVersion: import.meta.env.APP_VERSION,
  }),
  setup() {
    const authStore = useAuthStore();
    const indoStore = useIndoStore();
    return { authStore, indoStore };
  },
  computed: {
    tempPassword() {
      return this.authStore.tempPassword;
    },
    rules() {
      return {
        username: [
          {
            required: true,
            message: this.$t("el_usuario_es_requerido"),
            trigger: ["blur", "input"],
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("la_contrasena_es_requerida"),
            trigger: ["blur", "input"],
          },
        ],
      };
    },
  },
  watch: {
    "$i18n.locale"() {
      this.$refs.formRef?.restoreValidation();
    },
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenSize);
  },
  created() {
    const savedCredentials = localStorage.getItem("savedCredentials");
    if (savedCredentials) {
      try {
        const { username, password, remember } = JSON.parse(savedCredentials);
        if (remember && username) {
          this.formData.username = username;
          this.remember = true;
        }
        // Versiones anteriores guardaban también la contraseña: se purga.
        if (password !== undefined) {
          localStorage.setItem("savedCredentials", JSON.stringify({ username, remember }));
        }
      } catch (error) {
        localStorage.removeItem("savedCredentials");
      }
    }
  },
  methods: {
    checkScreenSize() {
      this.isSmallScreen = window.innerWidth < 640;
      this.isLargeScreen = window.innerWidth >= 1920;
    },
    async validate() {
      try {
        await this.$refs.formRef.validate();
      } catch (errors) {
        return;
      }

      this.showLoader = true;
      this.error = false;
      try {
        const ret = await this.authStore.Login({
          username: this.formData.username,
          password: this.formData.password,
        });

        this.indoStore.emptyData();
        await this.indoStore.PostLogin();

        if (this.remember) {
          localStorage.setItem(
            "savedCredentials",
            // Sólo el usuario: la sesión la mantiene el refresh token.
            JSON.stringify({
              username: this.formData.username,
              remember: true,
            }),
          );
        } else {
          localStorage.removeItem("savedCredentials");
        }

        sessionService.startSessionTimer();

        if (ret === 20) {
          this.showChangePasswordModal = true;
        } else {
          this.$router.push("/dashboard");
        }
        this.showLoader = false;
      } catch (error) {
        this.error = true;
        this.errorMessage = error;
        this.showLoader = false;
        localStorage.removeItem("savedCredentials");
        sessionService.clearSessionTimer();
      }
    },
    handleChangePasswordCancel() {
      this.authStore.Logout();
      this.showChangePasswordModal = false;
    },
    handleChangePasswordSuccess() {
      this.$router.push("/dashboard");
    },
  },
  beforeUnmount() {
    // Solo limpiar el timer si hay un error o si explícitamente se cancela el login
    // El timer debe continuar después del login exitoso
  },
};
</script>

<style lang="scss" scoped>
.section-login {
  @apply overflow-hidden relative bg-cover bg-no-repeat min-h-screen;
  background-image: url("../assets/login/Optico_estandar.png");
  background-position: 75% center;
  background-size: cover;

  .container-content {
    @apply w-full max-w-[1920px] mx-auto px-2 sm:px-3 md:px-4 lg:px-6 xl:px-8;
  }

  .firstForm {
    @apply w-full lg:w-[53%] flex items-center min-h-[calc(100vh-150px)] sm:min-h-[calc(100vh-200px)] lg:min-h-screen;
  }

  .login-section {
    @apply w-full;
  }

  .login-wrapper {
    @apply mx-auto p-3 sm:p-4 md:p-5 lg:p-6 xl:p-6 2xl:p-6 my-2 sm:my-3 md:my-4 lg:my-5 xl:my-[50px] bg-white flex flex-col items-center w-full max-w-[calc(100%-1rem)] sm:max-w-[calc(100%-1.5rem)] md:max-w-[500px] lg:max-w-[500px] xl:max-w-[500px] 2xl:max-w-[500px];

    @media (max-height: 700px) {
      @apply p-2 sm:p-2.5 md:p-3 lg:p-3 my-1 sm:my-1.5 md:my-2 lg:my-2;
    }

    &.logos-only {
      @apply mb-0 pb-3 sm:pb-4 md:pb-5 lg:pb-6 xl:pb-6 2xl:pb-6;

      @media (max-height: 700px) {
        @apply pb-2 sm:pb-2.5 md:pb-3 lg:pb-3;
      }
    }

    &.form-only {
      @apply mt-0 pt-3 sm:pt-4 md:pt-5 lg:pt-6 xl:pt-6 2xl:pt-6;

      @media (max-height: 700px) {
        @apply pt-2 sm:pt-2.5 md:pt-3 lg:pt-3;
      }
    }

    .logos-wrapper {
      @apply flex flex-wrap gap-2 sm:gap-4 md:gap-8 lg:gap-20 justify-center items-end mb-0;

      @media (max-height: 700px) {
        @apply gap-1 sm:gap-2 md:gap-3 lg:gap-4;
      }

      .wrapper__logo {
        @apply h-auto max-h-[35px] sm:max-h-[55px] md:max-h-[70px] lg:max-h-[80px] w-auto;

        @media (max-height: 700px) {
          @apply max-h-[30px] sm:max-h-[40px] md:max-h-[50px] lg:max-h-[60px];
        }

        &--optovision {
          @apply max-h-[52px] sm:max-h-[82px] md:max-h-[105px] lg:max-h-[120px];

          @media (max-height: 700px) {
            @apply max-h-[45px] sm:max-h-[60px] md:max-h-[75px] lg:max-h-[90px];
          }
        }
      }
    }

    .logo_bottom {
      @apply mt-2 sm:mt-4 md:mt-5 lg:mt-6 self-center;

      @media (max-height: 700px) {
        @apply mt-1 sm:mt-1.5 md:mt-2 lg:mt-2.5;
      }

      .align {
        @apply h-auto max-h-[20px] sm:max-h-[30px] md:max-h-[40px] w-auto;

        @media (max-height: 700px) {
          @apply max-h-[15px] sm:max-h-[18px] md:max-h-[22px];
        }
      }
    }

    .title {
      @apply text-lg sm:text-xl md:text-2xl lg:text-[32px] pt-0 font-bold text-center lg:text-left w-full;

      @media (max-height: 700px) {
        @apply text-base sm:text-lg md:text-xl lg:text-2xl;
      }
    }

    .text {
      @apply text-sm sm:text-base md:text-lg pt-0 sm:pt-1 md:pt-2 font-bold text-black text-center lg:text-left w-full;

      @media (max-height: 700px) {
        @apply text-xs sm:text-sm md:text-base pt-0;
      }
    }

    :deep(.n-form) {
      @apply w-full pt-2 sm:pt-3 md:pt-4 lg:pt-5;
      max-width: 100%;

      @media (max-height: 700px) {
        @apply pt-1 sm:pt-1.5 md:pt-2 lg:pt-2;
      }
    }

    :deep(.n-form-item) {
      @apply mb-1.5 sm:mb-2 md:mb-2.5 lg:mb-3;
      width: 100%;

      @media (max-height: 700px) {
        @apply mb-1 sm:mb-1 md:mb-1.5 lg:mb-2;
      }
    }

    .error-message {
      @apply w-full text-xs sm:text-sm text-red-600 mb-1 sm:mb-1.5 md:mb-2;

      @media (max-height: 700px) {
        @apply mb-0.5 sm:mb-0.5 md:mb-1;
      }
    }

    // Cuando no hay error, reducir el margen del form-item anterior
    :deep(.n-form-item[path="password"]) {
      margin-bottom: 0.375rem;

      @media (min-width: 640px) {
        margin-bottom: 0.5rem;
      }

      @media (min-width: 768px) {
        margin-bottom: 0.625rem;
      }

      @media (min-width: 1024px) {
        margin-bottom: 0.75rem;
      }

      @media (max-height: 700px) {
        margin-bottom: 0.25rem;

        @media (min-width: 640px) {
          margin-bottom: 0.25rem;
        }

        @media (min-width: 768px) {
          margin-bottom: 0.375rem;
        }
      }
    }

    :deep(.n-form-item-label) {
      @apply text-xs sm:text-xs md:text-sm font-bold text-rst_secondary;
    }

    :deep(.n-input) {
      @apply w-full max-w-full box-border;
    }

    :deep(.n-input-wrapper) {
      @apply w-full max-w-full;
    }

    :deep(.n-input__input-el) {
      @apply text-sm sm:text-base;
    }

    .checkbox-wrapper {
      @apply flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-3 md:gap-0 mt-0 sm:mt-0.5 md:mt-1 w-full;

      @media (max-height: 700px) {
        @apply gap-1 sm:gap-2 md:gap-0 mt-0;
      }
    }

    .remember-checkbox {
      @apply m-0 p-0 flex items-center;

      :deep(.n-checkbox) {
        @apply m-0 p-0 flex items-center;
        margin-right: 0.25rem;
      }

      :deep(.n-checkbox-box) {
        @apply m-0 flex items-center;
      }

      :deep(.n-checkbox__label) {
        @apply text-xs sm:text-xs md:text-sm m-0 p-0 ml-1 flex items-center;
        line-height: 1;
      }
    }

    :deep(.n-checkbox) {
      @apply text-xs sm:text-xs md:text-sm m-0 p-0;

      @media (max-height: 700px) {
        @apply text-xs;
      }
    }

    .forgot-link {
      @apply text-xs sm:text-xs md:text-sm text-rst_secondary font-bold hover:text-primary_dark transition-colors;

      @media (max-height: 700px) {
        @apply text-xs;
      }
    }

    :deep(.n-button) {
      @apply w-full max-w-full box-border mt-2 sm:mt-2.5 md:mt-3 lg:mt-4;

      @media (max-height: 700px) {
        @apply mt-1 sm:mt-1.5 md:mt-2 lg:mt-2;
      }
    }

    :deep(.n-button__content) {
      @apply text-sm sm:text-base;

      @media (max-height: 700px) {
        @apply text-xs sm:text-sm;
      }
    }
  }

  .info-section {
    @apply block w-full bg-[#333334] py-6 sm:py-8 md:py-10 lg:py-[63px];

    .content-wrapper {
      @apply flex flex-col lg:flex-row items-start lg:items-end gap-6 sm:gap-8 md:gap-10 justify-between;
    }

    .title {
      @apply text-lg sm:text-xl md:text-2xl lg:text-[32px] leading-[24px] sm:leading-[28px] md:leading-[32px] lg:leading-[40px] font-bold text-white max-w-full lg:max-w-[660px] text-start;
    }

    .secundary-button {
      @apply inline-block px-3 sm:px-4 md:px-6 lg:px-8 py-1.5 sm:py-2 md:py-3 bg-white text-[#333334] font-bold text-xs sm:text-sm md:text-base rounded hover:bg-gray-100 transition-colors text-center w-full sm:w-auto;
    }
  }
}

:deep(.n-spin-container) {
  min-height: 100vh;
}
</style>
